import BeeImage from "../assets/images/bees/perdita_pallidipennis.jpg";
import HypercaciaeaeImage from "../assets/images/hypericum.jpg";
import PhaeophysciaPhoto from "../assets/images/lichen/phaeophyscia.png";

interface AuthorType {
  name: string;
  avatar: string;
}

interface ResearchCardType {
  title: string;
  description: string;
  isPdf: boolean;
  link?: string;
  pdf?: string;
  image: string;
  author: AuthorType;
}

const ResearchCards: ResearchCardType[] = [
  {
    title: "Lichen Flora",
    description:
      "Lichens of the 53 counties that encompass the region around the southern end of Lake Michigan",
    link: "/research/lichen",
    image: PhaeophysciaPhoto,
    author: {
      name: "Gerould Wilhelm",
      avatar: "/images/avatar1.jpg",
    },
    isPdf: false,
  },
  {
    title: "Bees of the Southern Lake Michigan Region Project",
    description:
      "A work discussing the regional distributions of 513 bee species identified by the authors",
    link: "/research/bees",
    image: BeeImage,
    author: {
      name: "Laura Rericha-Anchor",
      avatar: "/images/avatar2.jpg",
    },
    isPdf: false,
  },
  {
    title: "Illustrated Guides",
    description:
      "See the complete list of Illustrated Guides to the Vascular Plants of the Chicago Region",
    link: "/research",
    image: HypercaciaeaeImage,
    author: {
      name: "Gerould Wilhelm",
      avatar: "/images/avatar1.jpg",
    },
    isPdf: false,
  },
  // {
  //   title: "Hypericaceae of the Chicago Region",
  //   description:
  //     "Distribution, Diversity, and Conservation Status of Hypericaceae in the Urban and Suburban Landscapes of the Chicago Region",
  //   image: HypercaciaeaeImage,
  //   author: {
  //     name: "Gerould Wilhelm",
  //     avatar: "/images/avatar1.jpg",
  //   },
  //   isPdf: true,
  //   pdf: HypercaiceaePDF,
  // },
  // {
  //   title: "Hawthorns of the Chicago Region",
  //   description:
  //     "A Comprehensive Study of Hawthorn (Crataegus) Diversity in the Chicago Region",
  //   image: HawthornPhoto,
  //   author: {
  //     name: "Gerould Wilhelm",
  //     avatar: "/images/avatar2.jpg",
  //   },
  //   isPdf: true,
  //   pdf: HawthornsPDF,
  // },
  // {
  //   title: "Willows of the Chicago Region",
  //   description:
  //     "A Guide to Identifying Willows (Salix) in the Chicago Region: Key Characteristics and Distributions",
  //   image: WillowPhoto,
  //   author: {
  //     name: "Gerould Wilhelm",
  //     avatar: "/images/avatar1.jpg",
  //   },
  //   isPdf: true,
  //   pdf: WillowsPDF,
  // },
];

export { ResearchCards };
export type { ResearchCardType, AuthorType };
